import { useEffect, useState } from "react";
import { PageMeta } from "@shared/seo/page-meta";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";

const Markdown = styled.article`
  margin: 0 auto;
  line-height: 1.65;

  h1 { font-size: 32px; margin: 24px 0 12px; }
  h2 { font-size: 24px; margin: 22px 0 10px; }
  h3 { font-size: 18px; margin: 18px 0 8px; }

  p { margin: 30px 0; }

  ul, ol { padding-left: 22px; margin: 10px 0; }
  li { margin: 6px 0; list-style: inside;}

  a {
    text-decoration: underline;
    &:hover { opacity: 0.85; }
  }

  blockquote {
    margin: 12px 0;
    padding: 8px 12px;
    border-left: 4px solid currentColor;
    opacity: 0.9;
  }

  hr { margin: 18px 0; opacity: 0.2; }

  pre {
    padding: 12px;
    border-radius: 10px;
    overflow-x: auto;
  }

  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.95em;
  }

  /* inline code */
  p code, li code, td code {
    padding: 2px 6px;
    border-radius: 6px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 12px 0;
  }
  th, td {
    border: 1px solid rgba(255,255,255,0.12);
    padding: 8px;
    vertical-align: top;
  }
  th { text-align: left; }
`;


export const CommunityGuidePage: React.FC = () => {
  const [md, setMd] = useState('');

  useEffect(() => {
    // Загружаем через прокси /media/ для работы с заголовком Authorization
    // Документы лежат в бакете static, а не media
    fetch('/static/community_guide.md', { cache: "no-store" })
      .then((r) => r.text())
      .then(setMd)
      .catch(() => setMd("Не удалось загрузить документ."));
  }, []);

  return (
      <>
        <PageMeta
            title="Правила пространства — Plumme"
            description="Правила общения, поведения и взаимодействия участников закрытого клубного пространства Plumme."
            path="/community-guide"
        />

        <Markdown>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {md}
          </ReactMarkdown>
        </Markdown>
      </>
  );
};
